import React from "react";

const Header = ({ title = "", subtitle = "" }) => {
  return (
    <header className="site-header simple">
      <div className="content">
        <div className="text">
          <h1>{title}</h1>
          <p>{subtitle}</p>
        </div>
      </div>
    </header>
  );
};

export default Header;
